const productTypeToCardTypeMap: Record<string, string> = {
  // English product types
  Course: "singleCourseTags",
  "Certificate Program": "programTags",
  "Professional Certificate": "programTags",
  MicroBachelors: "programTags",
  MicroMasters: "programTags",
  XSeries: "programTags",
  "Executive Education": "execEdTags",
  Bachelors: "degreeTags",
  Masters: "degreeTags",
  "Doctoral Program": "degreeTags",
  "Licensure Program": "programTags",
  "Offered on Emeritus": "execEdTags",
  "Offered through Shorelight": "degreeTags",

  // Spanish product types
  Curso: "singleCourseTags",
  "Programa de certificación": "programTags",
  "Certificado profesional": "programTags",
  "Educación ejecutiva": "execEdTags",
  Licenciatura: "degreeTags",
  "Título de maestría": "degreeTags",
  "Programa de doctorado": "degreeTags",
  "Programa de licenciatura": "programTags",
  "Disponible en Emeritus": "execEdTags",
  "Disponible en Shorelight": "degreeTags",
};

export const mapTypeToProductCardType = (type: string): string => {
  return productTypeToCardTypeMap[type] || "singleCourseTags"; // default to singleCourseTags if type not found
};
